style= require('./users.styl')
.users-header
  header
    .count= 'Users'
      span
        =this.res?.length || this.users?.length
    .search
      ft-form-control(
        type="search",
        placeholder="Search user",
        (input)=this.filterUsers(e)
      )
    .create
      ft-button(primary, (click)=this.createUser()) Create User

.users
  .users-title
    .name Name
    .email Email
    .date((click)=this.sortUsers('date'))
      =' Date & time'
      //- ft-icon(name='ui--table_sort')
    .role
      = 'Role'
      //- ft-icon(name='ui--table_sort')
    .controls Remove from list
  each user in res
    .entry
      .info(class=user.role)
        .name
          span=this.abriviature(user.username)
          = user.username
        .email= user.email
        .date=  moment(user.createdAt).format('DD MMM YYYY, h:mm')
        select((change)=this.changeRole(user, e.target.value)).role
          each role in ['admin', 'moderator', 'user']
            option(value=role selected=(user.role === role))= role
        .controls
          ft-button( transparent,(click)=this.remove(user)) Remove

